// src/pages/About.js
import React from "react";

export default function About() {
  const styles = {
    page: {
      padding: "20px",
      maxWidth: "900px",
      margin: "0 auto",
      lineHeight: "1.6",
      fontFamily: "Arial, sans-serif",
    },
    title: {
      fontSize: "28px",
      fontWeight: "bold",
      color: "#4A148C",
      marginBottom: "10px",
      textAlign: "center",
    },
    subtitle: {
      fontSize: "20px",
      fontWeight: "600",
      marginTop: "20px",
      color: "#333",
      borderLeft: "4px solid #4A148C",
      paddingLeft: "10px",
    },
    text: {
      fontSize: "16px",
      color: "#444",
      marginTop: "10px",
    },
    infoBox: {
      background: "#f8f4ff",
      padding: "15px",
      borderRadius: "10px",
      border: "1px solid #d7c4ff",
      marginTop: "15px",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      marginTop: "15px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
      borderRadius: "10px",
      overflow: "hidden",
    },
    th: {
      background: "#4A148C",
      color: "white",
      padding: "10px",
      fontSize: "17px",
    },
    td: {
      padding: "10px",
      borderBottom: "1px solid #ddd",
      background: "#faf5ff",
      fontWeight: "600",
    },
    mapImage: {
      width: "100%",
      borderRadius: "10px",
      marginTop: "10px",
    },
  };

  return (
    <div style={styles.page}>
      <h1 style={styles.title}>पंचायत समिती बल्लारपूर</h1>

      

      {/* 📍 Office Details */}
      <div style={styles.infoBox}>
        <h2 style={styles.subtitle}>📍 कार्यालयाचा पत्ता</h2>
        <p style={styles.text}>
          <b>Address:</b> Railway Nagar Ward, Balharshah, Chandrapur,  
          MSH-264, Mancherial Nagpur Road, Ballarpur, Maharashtra 442701
        </p>

        <p style={styles.text}><b>Phone:</b> 9623210159</p>
          <p style={styles.text}><b>Email:</b>bdopsballarpur@gmail.com</p>

        <p style={styles.text}>
          <b>Office Hours:</b> सकाळी 10 ते सायंकाळी 5 (सोम–शनि)
        </p>
      </div>

      {/* About Panchayat Samiti */}
      <h2 style={styles.subtitle}>📘 पंचायत समिती म्हणजे काय?</h2>
      <p style={styles.text}>
        पंचायत समिती ही <b>तालुका स्तरावरील स्थानिक स्वराज्य संस्था</b> आहे.
        जिल्हा परिषदेअंतर्गत काम करणारी ही अत्यंत महत्त्वाची संस्था असून
        विकास योजना, प्रकल्प, शाळा, आरोग्यसेवा व पायाभूत सुविधा यांचे
        नियोजन व अंमलबजावणी करते.
      </p>

      {/* Functions */}
      <h2 style={styles.subtitle}>📌 पंचायत समितीची प्रमुख कामे</h2>
      <p style={styles.text}>
        ✔ ग्रामपंचायतींचे मार्गदर्शन  
        ✔ तालुक्यातील विकास योजनांचे नियोजन  
        ✔ आरोग्य, शिक्षण, पाणीपुरवठा, सिंचन योजना  
        ✔ शासकीय योजनांचे लाभ नागरिकांपर्यंत पोहोचवणे  
        ✔ निधी वितरण आणि लेखा परीक्षण  
        ✔ अंगणवाडी, शाळा, आरोग्य केंद्रांचे नियंत्रण  
      </p>

      {/* Features */}
      <h2 style={styles.subtitle}>📝 बल्लारपूर पंचायत समितीची वैशिष्ट्ये</h2>
      <p style={styles.text}>
        ✔ चंद्रपूर जिल्ह्यातील एक महत्त्वाची पंचायत समिती  
        ✔ औद्योगिक क्षेत्र, वनक्षेत्र आणि खाण क्षेत्र मोठ्या प्रमाणात  
        ✔ जलसंपदा, रस्ते, शिक्षण प्रकल्पांची मोठी गरज  
        ✔ ग्रामीण विकासात अग्रगण्य भूमिका  
      </p>

      {/* Mission */}
      <h2 style={styles.subtitle}>🎯 आमचे उद्दिष्ट</h2>
      <p style={styles.text}>
        बल्लारपूर तालुक्यास सर्वांगीण विकासाच्या मुख्य प्रवाहात आणणे,
        शासकीय सुविधा घराघरापर्यंत पोहोचवणे, पायाभूत सुविधा मजबूत करणे
        आणि नागरिकांच्या जीवनमानात सुधारणा करणे हे आमचे ध्येय आहे.
      </p>

      {/* ⭐ Extra Information Section ⭐ */}
      <h2 style={styles.subtitle}>📊 बल्लारपूर तालुका माहिती</h2>

      <table style={styles.table}>
        <thead>
          <tr>
            <th style={styles.th}>माहिती</th>
            <th style={styles.th}>तपशील</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={styles.td}>एकूण लोकसंख्या (2011)</td>
            <td style={styles.td}>1,34,540</td>
          </tr>
          <tr>
            <td style={styles.td}>पुरुष</td>
            <td style={styles.td}>69,461</td>
          </tr>
          <tr>
            <td style={styles.td}>स्त्रिया</td>
            <td style={styles.td}>65,079</td>
          </tr>
          <tr>
            <td style={styles.td}>शहरी लोकसंख्या</td>
            <td style={styles.td}>1,02,686 (76.3%)</td>
          </tr>
          <tr>
            <td style={styles.td}>ग्रामीण लोकसंख्या</td>
            <td style={styles.td}>31,854 (23.7%)</td>
          </tr>
          <tr>
            <td style={styles.td}>नगर परिषद</td>
            <td style={styles.td}>बल्लारपूर नगर परिषद</td>
          </tr>
          <tr>
            <td style={styles.td}>2025 अंदाजित लोकसंख्या</td>
            <td style={styles.td}>1,28,000+</td>
          </tr>
          <tr>
            <td style={styles.td}>एकूण ग्रामपंचायती</td>
            <td style={styles.td}>—</td>
          </tr>
          <tr>
            <td style={styles.td}>तालुक्यातील प्रमुख उद्योग</td>
            <td style={styles.td}>पेपर मिल, कोळसा खाण, सिमेंट इंडस्ट्री</td>
          </tr>
        </tbody>
      </table>
      {/* Tourist Places Section */}
      <h2 style={styles.subtitle}>🌄 बल्लारपूरमधील प्रमुख पर्यटन स्थळे</h2>
      <p style={styles.text}>
        बल्लारपूरमध्ये इतिहास, निसर्ग आणि धार्मिकता यांचा सुंदर मिलाप दिसून येतो.
        येथे भेट देण्यासाठी काही प्रसिद्ध ठिकाणे:
      </p>

      <ul style={{ marginTop: "10px", paddingLeft: "20px", color: "#444", fontSize: "16px" }}>
        <li><b>बल्लारपूर किल्ला:</b> वर्धा नदी किनारी वसलेला ऐतिहासिक किल्ला, गोंड राजा खांडक्या बल्लाल शाह यांनी बांधलेला.</li>
        <li><b>ताडोबा अंधारी व्याघ्र प्रकल्प:</b> बल्लारपूरजवळील प्रसिद्ध वाघ संवर्धन क्षेत्र, वन्यजीव पाहण्यासाठी उत्तम ठिकाण.</li>
        <li><b>गुंडा पॉईंट:</b> निसर्गरम्य दृश्ये व शांत वातावरणासाठी प्रसिद्ध.</li>
        <li><b>महाकाली मंदिर:</b> धार्मिक महत्त्व असलेले सुंदर मंदिर, बल्लारपूर–चंद्रपूर परिसरात स्थित.</li>
        <li><b>चंद्रपूर सुपर थर्मल पॉवर स्टेशन:</b> आशियातील एक मोठे व महत्त्वाचे औद्योगिक केंद्र.</li>
      </ul>

      {/* Final Statement */}
      <p style={{ ...styles.text, marginTop: "20px", fontWeight: "bold" }}>
        बल्लारपूर तालुक्याचा सर्वांगीण आणि शाश्वत विकास साधणे हे पंचायत समितीचे
        मुख्य ध्येय आहे.
      </p>
    </div>
  );
}
